import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Unit Details (/unit/:unitID)
 */
export const unitDetailsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_UnitDetails_Welcome_Title"),
    description: t("Tour_UnitDetails_Welcome_Description"),
    target: () => queryTourTarget("unit-details-header"),
    placement: "bottom",
  },
  {
    title: t("Tour_UnitDetails_Invite_Title"),
    description: t("Tour_UnitDetails_Invite_Description"),
    target: () => queryTourTarget("unit-invite-tenant"),
    placement: "left",
  },
  {
    title: t("Tour_UnitDetails_Status_Title"),
    description: t("Tour_UnitDetails_Status_Description"),
    target: () => queryTourTarget("unit-status"),
    placement: "bottom",
  },
  {
    title: t("Tour_UnitDetails_Tabs_Title"),
    description: t("Tour_UnitDetails_Tabs_Description"),
    target: () => queryTourTarget("unit-details-tabs"),
    placement: "bottom",
  },
];
